// extracted by mini-css-extract-plugin
export default {"wrapper":"BingoRooms-module__wrapper","header":"BingoRooms-module__header","loader":"BingoRooms-module__loader"};